module.exports = __webpack_public_path__ + "static/media/049-sharing.8059c6c7.svg";